<template>
  
  <div class="container-fluid">
    <div class="row no-gutter">
      <div class="login d-flex align-items-center py-5">

        <div class="container" style="background-color: #264740;">
          <div class="row" >
            <div v-if="a==1" class="col-lg-10 col-xl-7 mx-auto" >
              <div >
                <div class="mb-3">
                  <input id="inputEmail" type="email" v-model="email" placeholder="Email address" required=""
                    autofocus="" class="form-control rounded-pill border-0 shadow-sm px-4" />
                </div>
                <div class="mb-3">
                  <input id="inputPassword" type="password" v-model="password" placeholder="Password" required=""
                    class="form-control rounded-pill border-0 shadow-sm px-4 text-primary" />
                </div>
                <div class="form-check">
                  <input id="customCheck1" type="checkbox" checked class="form-check-input" />
                  <label for="customCheck1" class="form-check-label" style="color: #fff;">Rememberhh  password</label>
                </div>

                <div class="form-check">
                  <input id="customCheck1" type="checkbox" @click="a = (a==1?2:1)" class="form-check-input" />
                  <label for="customCheck1" class="form-check-label" style="color: #fff;">Signup</label>
                </div>

                <!-- <div class="d-flex col-sm-4 gap-2 mt-2">
                  <button type="submit"
                    class="btn btn-primary btn-block text-uppercase mb-2 rounded-pill shadow-sm">Sign in</button>
                </div> -->
              </div>
              <!-- Sign up if you don't have an account !
              <div class="d-flex col-sm-4 gap-2 mt-2">

                <button @click="a=2" class="btn btn-primary btn-block text-uppercase mb-2 rounded-pill shadow-sm ">Sign
                  up</button>
              </div> -->
            </div>
            <Signup v-if="a==2"></Signup>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>
<script>
import axios from 'axios';

import { mapActions, mapGetters, mapMutations } from "vuex";
import Signup from './Signup.vue';

export default {
  name: "Login",
  props : ["CheckOrder"],
  components: {
    Signup
  },
  data() {
    return {
      a: 1,
      email: "",
      password: "",
    };
  },
  methods: {
    ...mapActions(["loginProg"]),
    ...mapMutations(["addClientSuccess"]),
    // await axios.post(`https://space.monresto.menu/${apipath1}login`)
    async onSubmit() {
      let type = "Client";
      const form = {
        email: this.email,
        password: this.password,
      };
      this.loginProg(form).then((res)=>{
        if(res.ok){
          // window.location.href = '/'
          // this.$router.push('/client')
          
          console.log(res.client)
          this.addClientSuccess(res.client)
          this.CheckOrder();
        }
        // this.$router.push('Login')
      })
    }
  },
  components: { Signup }
}
</script>

<style>
  .btn-primary{
    background: #f05d2e !important;  
    border: unset !important;
    }
</style>